import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';
import ImpressumPage from '../pages/impressum/page';
import DatenschutzPage from '../pages/datenschutz/page';
import AGBPage from '../pages/agb/page';
import SocialMediaPage from '../pages/social-media/page';
import FotoVideographiePage from '../pages/foto-videographie/page';
import WebdesignEntwicklungPage from '../pages/webdesign-entwicklung/page';
import KontaktPage from '../pages/kontakt/page';
import PortfolioPage from '../pages/portfolio/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/social-media',
    element: <SocialMediaPage />,
  },
  {
    path: '/foto-videographie',
    element: <FotoVideographiePage />,
  },
  {
    path: '/webdesign-entwicklung',
    element: <WebdesignEntwicklungPage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/datenschutz',
    element: <DatenschutzPage />,
  },
  {
    path: '/agb',
    element: <AGBPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;